const AUTH_BE = () => {
  return window.location.host.includes("localhost") ||
    window.location.host.includes("lh.eclear-solutions.com")
    ? `https://dev.eclear-solutions.com/ec-authorization-be/v1/`
    : `https://${window.location.host}/ec-authorization-be/v1/`;
};

const EC_AUTH_BE_V2 = () => {
  return window.location.host.includes("localhost") ||
    window.location.host.includes("lh.eclear-solutions.com")
    ? `https://dev.eclear-solutions.com/ec-authorization-be/v2/`
    : `https://${window.location.host}/ec-authorization-be/v2/`;
};

export const URLS: any = {
  // ______________________BASE URLS______________________
  EC_AUTH_BE: () => {
    return window.location.host.includes("localhost") ||
      window.location.host.includes("lh.eclear-solutions.com")
      ? `https://dev.eclear-solutions.com/ec-authorization-be/v1/`
      : `https://${window.location.host}/ec-authorization-be/v1/`;
  },
  EC_SPOT_BE: () => {
    return window.location.host.includes("localhost") ||
      window.location.host.includes("lh.eclear-solutions.com")
      ? `https://dev.eclear-solutions.com/ec-spot-be/v1/`
      : `https://${window.location.host}/ec-spot-be/v1/`;
  },

  // ______________________ENDPOINTS______________________
  REGISTRATION_LINK: "registration-link/",
  LOGIN: "user-manager/login",
  REFRESHTOKEN: "user-manager/refresh-token",
  USER: (sub: any) => {
    return window.location.host.includes("localhost") ||
      window.location.host.includes("lh.eclear-solutions.com")
      ? `https://dev.eclear-solutions.com/ec-authorization-be/v1/user/${sub}`
      : `https://${window.location.host}/ec-authorization-be/v1/user/${sub}`;
  },

  USER_STATUS: (userId: string) => {
    return `${AUTH_BE()}user/${userId}/status`;
  },

  GET_USER_BY_ID: (merhcantId: string) => {
    return `${EC_AUTH_BE_V2()}merchant/${merhcantId}/users`;
  },

  GET_MERCHANT: `${EC_AUTH_BE_V2()}merchant`
};
